import { motion } from "framer-motion";

const pains = [
  {
    n: "01",
    title: "Anrufe gehen unter",
    text: "Während Sie auf der Baustelle oder beim Patienten sind, klingelt das Telefon ins Leere. Der Kunde ruft beim Nächsten an.",
  },
  {
    n: "02",
    title: "Rückrufe werden vergessen",
    text: "Zettel, Zuruf, „mach ich später“ – am Ende bleibt die halbe Liste liegen und aus Interessenten werden keine Aufträge.",
  },
  {
    n: "03",
    title: "Angebote verlaufen im Sand",
    text: "Anfragen kommen per Telefon, WhatsApp und Formular. Ohne festen Ablauf geht der Überblick verloren – und damit Umsatz.",
  },
];

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative bg-[#0E1B2E] text-white py-24 sm:py-32 scroll-mt-24"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
            >
              <div className="flex items-center gap-3">
                <span className="h-px w-10 bg-[#9A8420]" />
                <span className="eyebrow text-[#C9A94A]">Kennen Sie das?</span>
              </div>
              <h2 className="mt-6 font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                Jeder verpasste Kontakt ist ein verlorener Auftrag.
              </h2>
              <p className="mt-6 text-base sm:text-lg text-slate-300/90 leading-relaxed max-w-md">
                Kleine Betriebe verlieren keine Kunden, weil sie schlechte Arbeit
                machen — sondern weil im Alltag Anfragen liegen bleiben. Genau da
                setzen wir an.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-white/10 border-t border-white/10">
              {pains.map((p, i) => (
                <motion.div
                  key={p.n}
                  data-testid={`problem-card-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.1 }}
                  className="group flex gap-6 sm:gap-8 py-8 sm:py-10"
                >
                  <span className="font-extrabold text-4xl sm:text-5xl text-[#9A8420] leading-none tabular-nums transition-colors group-hover:text-[#C9A94A]">
                    {p.n}
                  </span>
                  <div>
                    <h3 className="font-bold text-2xl sm:text-3xl text-white">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-slate-300/90 leading-relaxed max-w-lg">
                      {p.text}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
